import React, { useState, useEffect, useRef } from 'react';

import { Container } from '@material-ui/core';

import { useLocation } from 'react-router-dom';

import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const IPGTransaction = () => {
    const formRef = useRef(null);

    const location = useLocation();
    const ResponseSuccessURL = location.state.ResponseSuccessURL;
    const ResponseFailURL = location.state.ResponseFailURL;
    const FormActionURL = location.state.FormActionURL;
    const Hash = location.state.Hash;
    const TxnDatetime = location.state.TxnDatetime;
    const StoreName = location.state.StoreName;
    const Amount = location.state.Amount;
    const Currency = location.state.Currency;

    const initialValues = {
        ResponseSuccessURL: ResponseSuccessURL,
        ResponseFailURL: ResponseFailURL,
        FormActionURL: FormActionURL,
        Hash: Hash,
        TxnDatetime: TxnDatetime,
        StoreName: StoreName,
        Amount: Amount,
        Currency: Currency
    };

    const [FormObj, setFormObj] = useState(initialValues);

    useEffect(() => {
        formRef.current.submit();
    }, []);
    return (
        <CustomContainer>
            <form
                ref={formRef}
                id="form1"
                method="post"
                name="form1"
                action={FormObj.FormActionURL}
            >
                <input type="hidden" name="txntype" value="sale" />
                <input type="hidden" name="timezone" value="IST" />
                <input
                    type="hidden"
                    name="txndatetime"
                    value={FormObj.TxnDatetime}
                />
                <input type="hidden" name="hash" value={FormObj.Hash} />
                <input
                    type="hidden"
                    name="storename"
                    value={FormObj.StoreName}
                />
                <input type="hidden" name="mode" value="payonly" />
                <input type="hidden" name="currency" value={FormObj.Currency} />

                <input
                    type="hidden"
                    name="chargetotal"
                    value={FormObj.Amount}
                />

                <input type="hidden" name="language" value="en_EN" />
                <input
                    type="hidden"
                    name="authenticateTransaction"
                    value="true"
                />
                <input
                    type="hidden"
                    name="responseFailURL"
                    value={FormObj.ResponseFailURL}
                />
                <input
                    type="hidden"
                    name="responseSuccessURL"
                    value={FormObj.ResponseSuccessURL}
                />
                <input type="submit" value="Redirect" />
            </form>
        </CustomContainer>
    );
};
